import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { getClassNames } from '../../../../utils/util';

import './help-center-menu.scss';

const HelpCenterMenu = () => {
  const userGroups = useSelector(({ party }) => party.userGroups);

  const location = useLocation();

  const navigate = useNavigate();

  const { pathname } = location;

  const isAdmin = userGroups.includes('admin');
  const isFacilitator = userGroups.includes('facilitator');

  return (
    <section className="help-center-menu">
      <p className="help-center-menu__title">Help Center</p>

      <section className="help-center-menu__buttons">
        <button
          className={getClassNames('help-center-menu__button', {
            active: pathname.includes('frequently-asked-questions'),
          })}
          onClick={() => navigate('/help-center/frequently-asked-questions')}
        >
          FAQ
        </button>
        <button
          className={getClassNames('help-center-menu__button', {
            active: pathname.includes('tutorials'),
          })}
          onClick={() => navigate('/help-center/tutorials')}
        >
          Tutorials
        </button>
        {!(isAdmin || isFacilitator) && (
          <button
            className={getClassNames('help-center-menu__button', { active: pathname.includes('contact-us') })}
            onClick={() => navigate('/help-center/contact-us')}
          >
            Contact Us
          </button>
        )}
      </section>
    </section>
  );
};

export default HelpCenterMenu;
